import { render, staticRenderFns } from "./ProjectPreview.vue?vue&type=template&id=4fb0293a&scoped=true&"
import script from "./ProjectPreview.vue?vue&type=script&lang=js&"
export * from "./ProjectPreview.vue?vue&type=script&lang=js&"
import style0 from "./ProjectPreview.vue?vue&type=style&index=0&id=4fb0293a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb0293a",
  null
  
)

export default component.exports